import { COLOR, LazyImage as _LazyImage } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const ULWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 10px;
`;

export const LIWrapper = styled.li`
  list-style: none;
  background-color: ${COLOR.GRAY100.code};
  margin-bottom: 2px;
`;

export const NavAccordionItem = styled.nav<{ isOpen: boolean }>`
  overflow: hidden;
  ${({ isOpen }) =>
    !isOpen
      ? `
          max-height: 0;
          transition: max-height 0.15s cubic-bezier(0, 1, 0, 1);
        `
      : `
          transition: max-height 0.15s cubic-bezier(1, 0.09, 1, 0.31);
          max-height: 1000px;
        `}
`;

export const DivListContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7.5px 10px;
  min-height: 45px;
`;

export const DivTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LazyImage = styled(_LazyImage)`
  > picture {
    background: none;
  }
`;

export const SpanMenuNameWithNewTagWrapper = styled.span`
  padding-left: 9.5px;
`;
